import { render } from "./SymptomsDetailsSection.vue?vue&type=template&id=1e66a298"
import script from "./SymptomsDetailsSection.vue?vue&type=script&lang=js"
export * from "./SymptomsDetailsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__